export const Types = {
  GET_REQUEST: "reasons/GET_REQUEST",
  GET_SUCCESS: "reasons/GET_SUCCESS",
  GET_FAILURE: "reasons/GET_FAILURE",

  GET_LIST_REQUEST: "reasons/GET_LIST_REQUEST",
  GET_LIST_SUCCESS: "reasons/GET_LIST_SUCCESS",
  GET_LIST_FAILURE: "reasons/GET_LIST_FAILURE",

  CREATE_REQUEST: "reasons/CREATE_REQUEST",
  CREATE_SUCCESS: "reasons/CREATE_SUCCESS",
  CREATE_FAILURE: "reasons/CREATE_FAILURE",

  UPDATE_REQUEST: "reasons/UPDATE_REQUEST",
  UPDATE_SUCCESS: "reasons/UPDATE_SUCCESS",
  UPDATE_FAILURE: "reasons/UPDATE_FAILURE",
};

const initialState = {
  data: [],
  loading: true,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  search: {
    data: [],
    loading: false,
  },
};

export default function reasons(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.reason,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.reasons,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.SEARCH_REQUEST:
      return {
        ...state,
        search: {
          ...state.search,
          loading: true,
        },
      };
    case Types.SEARCH_SUCCESS:
      return {
        ...state,
        search: {
          ...state.search,
          loading: false,
          data: action.payload.reasons.data,
        },
      };
    case Types.SEARCH_FAILURE:
      return {
        ...state,
        search: {
          ...state.search,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getReasonRequest: (id) => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getReasonSuccess: (reason) => ({
    type: Types.GET_SUCCESS,
    payload: { reason },
  }),

  getReasonFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getReasonsRequest: () => ({
    type: Types.GET_LIST_REQUEST,
  }),

  getReasonsSuccess: (reasons) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { reasons },
  }),

  getReasonsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createReasonRequest: (data) => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createReasonSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createReasonFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateReasonRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateReasonSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateReasonFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  getReasonStoresRequest: (query = "") => ({
    type: Types.GET_STORES_REQUEST,
    payload: { query },
  }),

  getReasonStoresSuccess: (stores) => ({
    type: Types.GET_STORES_SUCCESS,
    payload: { stores },
  }),

  getReasonStoresFailure: () => ({
    type: Types.GET_STORES_FAILURE,
  }),

  searchReasonsRequest: (query = "") => ({
    type: Types.SEARCH_REQUEST,
    payload: { query },
  }),

  searchReasonsSuccess: (reasons) => ({
    type: Types.SEARCH_SUCCESS,
    payload: { reasons },
  }),

  searchReasonsFailure: () => ({
    type: Types.SEARCH_FAILURE,
  }),
};
